import React, { useState, useEffect } from "react";
import {
  FaBars,
  FaUserMd,
  FaCalendarAlt,
  FaEnvelope,
  FaBuilding,
  FaImages,
  FaSlidersH,
  FaUsers,
  FaSignOutAlt,
  FaTachometerAlt,
  FaBlog,
} from "react-icons/fa";
import axios from "axios";
import Appointments from "./Appointments";
import Contacts from "./Contacts";
import Departments from "./Departments";
import Doctors from "./Doctors";
import Galleries from "./Galleries";
import Sliders from "./Sliders";
import Users from "./Users";
import NewBlogs from "./NewBlogs";
import Swal from "sweetalert2";

const SummaryCard = ({ label, count, icon, onClick }) => (
  <div className="col-md-3 mt-3 mb-5 m-auto">
    <div
      className="card shadow p-3 d-flex align-items-center text-center"
      style={{ cursor: "pointer" }}
      onClick={onClick}
    >
      <div className="fs-3 text-primary">{icon}</div>
      <h5 className="mt-2">{label}</h5>
      <h4>{count}</h4>
    </div>
  </div>
);

const Dashboard = () => {

  const [collapsed, setCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("summary");

  const [summary, setSummary] = useState({
    appointments: 0,
    contacts: 0,
    departments: 0,
    doctors: 0,
    gallery: 0,
    sliders: 0,
    blogs: 0,
    users: 0,
  });

  const menuItems = [
    { key: "summary", label: "Dashboard", icon: <FaTachometerAlt /> },
    { key: "sliders", label: "Sliders", icon: <FaSlidersH /> },
    { key: "departments", label: "Departments", icon: <FaBuilding /> },
    { key: "appointments", label: "Appointments", icon: <FaCalendarAlt /> },
    { key: "doctors", label: "Doctors", icon: <FaUserMd /> },
    { key: "users", label: "Users", icon: <FaUsers /> },
    { key: "gallery", label: "Gallery", icon: <FaImages /> },
    { key: "blogs", label: "Blogs", icon: <FaBlog /> },
    { key: "contacts", label: "Contacts", icon: <FaEnvelope /> },
    { key: "logout", label: "Logout", icon: <FaSignOutAlt /> },
  ];

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out of your account.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, logout",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");

        Swal.fire({
          title: "Logged Out",
          text: "You have been logged out successfully.",
          icon: "success",
          timer: 1500,
          showConfirmButton: false,
        }).then(() => {
          window.location.href = "/login";
        });
      }
    });
  };

  useEffect(() => {
    const fetchSummary = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/admin/summary`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setSummary(res.data);
      } catch (err) {
        console.error("Failed to fetch summary", err);
      }
    };

    fetchSummary();
  }, []);

  const renderContent = () => {
    switch (activeSection) {
      case "gallery":
        return <Galleries />;
      case "sliders":
        return <Sliders />;
      case "departments":
        return <Departments />;
      case "appointments":
        return <Appointments />;
      case "doctors":
        return <Doctors />;
      case "users":
        return <Users />;
      case "blogs":
        return <NewBlogs />;
      case "contacts":
        return <Contacts />;
      case "summary":
      default:
        return (
          <div className="row">
            <SummaryCard
              label="Users"
              count={summary.users}
              icon={<FaUsers />}
              onClick={() => setActiveSection("users")}
            />
            <SummaryCard
              label="Doctors"
              count={summary.doctors}
              icon={<FaUserMd />}
              onClick={() => setActiveSection("doctors")}
            />
            <SummaryCard
              label="Departments"
              count={summary.departments}
              icon={<FaBuilding />}
              onClick={() => setActiveSection("departments")}
            />
            <SummaryCard
              label="Appointments"
              count={summary.appointments}
              icon={<FaCalendarAlt />}
              onClick={() => setActiveSection("appointments")}
            />

            <SummaryCard
              label="Sliders"
              count={summary.sliders}
              icon={<FaSlidersH />}
              onClick={() => setActiveSection("sliders")}
            />

            <SummaryCard
              label="Gallery"
              count={summary.gallery}
              icon={<FaImages />}
              onClick={() => setActiveSection("gallery")}
            />
            <SummaryCard
              label="Blogs"
              count={summary.blogs || 0}
              icon={<FaBlog />}
              onClick={() => setActiveSection("blogs")}
            />
            <SummaryCard
              label="Contacts"
              count={summary.contacts}
              icon={<FaEnvelope />}
              onClick={() => setActiveSection("contacts")}
            />
          </div>
        );
    }
  };

  return (
    <div className="container-fluid p-0">
      {/* Mobile Top Bar */}
      <div className="d-md-none bg-primary text-white p-2 d-flex justify-content-between align-items-center fixed-top">
        <h5 className="m-0">Menu</h5>
        <FaBars
          className="cursor-pointer"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        />
      </div>

      <div
        className="d-flex flex-column flex-md-row"
        style={{ minHeight: "100vh" }}
      >
        {/* Sidebar */}
        {(mobileMenuOpen || window.innerWidth >= 768) && (
          <div
            className={`bg-primary text-white p-3 d-flex flex-column position-fixed position-md-static`}
            style={{
              width: collapsed ? "60px" : "200px",
              minHeight: "100vh",
              transition: "width 0.3s",
              zIndex: 1020,
            }}
          >
            <div
              className="mb-4 mt-2 d-flex align-items-center justify-content-between w-100 "
              style={{
                color: "#006a8a",
                backgroundColor: "white",
                padding: 10,
              }}
            >
              {!collapsed && <h5 className="m-0">Menu</h5>}
              <FaBars
                className="cursor-pointer d-none d-md-inline"
                onClick={() => setCollapsed(!collapsed)}
              />
            </div>

            {menuItems.map((item) => (
              <button
                key={item.key}
                className={`btn btn-link text-white text-start w-100 d-flex align-items-center ${
                  activeSection === item.key ? "fw-bold" : ""
                }`}
                onClick={() => {
                  item.key === "logout"
                    ? handleLogout()
                    : setActiveSection(item.key);
                  setMobileMenuOpen(false); // Close menu on mobile
                }}
                style={{ padding: "0.5rem" }}
              >
                <span className="me-2 fs-5">{item.icon}</span>
                {!collapsed && <span>{item.label}</span>}
              </button>
            ))}
          </div>
        )}

        {/* Main Content */}
        <div
          className="flex-grow-1 p-3 bg-light"
          style={{
            marginLeft:
              window.innerWidth >= 768 ? (collapsed ? "60px" : "200px") : 0,
            transition: "margin-left 0.3s",
            marginTop: window.innerWidth < 768 ? "56px" : "0",
          }}
        >
          <div
            className="card shadow p-5 m-5"
            style={{ backgroundColor: "aliceblue" }}
          >
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
